import { useEffect, useContext } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import { ContentBody, ContentHeader } from 'components/shared/content'
import * as H from 'history'
import { ActionTableCell, ExTable, TableBody, TableHead, TableWrapper } from 'components/shared/widget'
import { ProbeLot, ProbeLotSearchForm } from 'entities/probe_lot'
import { useDeleteProbeLotApi, useFetchProbeLotsApi } from 'api/probe_lot'
import { probeLotColumnInfoList, ProbeLotTableData } from './probe_lot_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import { GlobalStateContext } from 'contexts/global_state_context'
import { useEffectSkipFirst, useForm } from 'utils/hooks'
import { Pagination } from 'components/shared/pagination'
import { EditProbeLotForm, NewProbeLotForm } from './probe_lot_form'
import { useState } from 'react'
import { SearchConditionView } from 'components/shared/search_drawer'

type Props = {
    history: H.History
}

const ProbeLotsPage = (props: Props) => {
    const params = useParams<{ id: string }>()
    const searchForm = useForm<ProbeLotSearchForm>({ probeId: Number(params.id) })
    const listApi = useFetchProbeLotsApi(searchForm)
    const globalState = useContext(GlobalStateContext)
    const probeLotDisplaySetting = useDisplaySetting(probeLotColumnInfoList(searchForm), 'ProbeLot')
    const deleteApi = useDeleteProbeLotApi()
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const [selectedProbeLot, setSelectedProbeLot] = useState<ProbeLot>({})

    useEffect(() => {
        listApi.execute()
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(deleteApi.loading)
        if (deleteApi.isSuccess()) {
            listApi.execute()
        }
    }, [deleteApi.loading])

    const handleClickRemoveFilter = (key: keyof ProbeLotSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    return (
        <>
            <EditProbeLotForm
                show={showEdit}
                probeLot={selectedProbeLot}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    setShowEdit(false)
                    listApi.execute()
                }}
            />
            <ContentHeader
                headerTitle="ProbeLots"
                left={
                    <>
                        <NewProbeLotForm onComplete={() => listApi.execute()} probeId={Number(params.id)} />
                        <SearchConditionView searchForm={searchForm} onClickRemoveButton={handleClickRemoveFilter} hiddenSearchParams={['probeId']} />
                    </>
                }
                right={
                    <>
                        <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                    </>
                }
            />
            <ContentBody>
                <TableWrapper>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <tr>
                                <ActionTableCell th></ActionTableCell>
                                <ActionTableCell th></ActionTableCell>
                                <TableHeads displaySetting={probeLotDisplaySetting} />
                            </tr>
                        </TableHead>
                        <TableBody loading={listApi.loading}>
                            {listApi.response.results.map((probeLot: ProbeLot) => {
                                return (
                                    <tr key={probeLot.id}>
                                        <ActionTableCell
                                            action={'delete'}
                                            onClick={() => {
                                                globalState.showConfirm('本当に削除しますか？(すでにStudyで使われている場合は削除できません)', () => {
                                                    deleteApi.execute(probeLot.id!)
                                                })
                                            }}
                                        />
                                        <ActionTableCell
                                            action={'edit'}
                                            onClick={() => {
                                                setSelectedProbeLot(probeLot)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ProbeLotTableData probeLot={probeLot} displaySetting={probeLotDisplaySetting} />
                                    </tr>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={listApi.pageSet} response={listApi.response}></Pagination>
                </TableWrapper>
            </ContentBody>
        </>
    )
}

export default withRouter(ProbeLotsPage)
